// icon:weather_star | Linea Iconset https://linea.io/ | Benjamin Sigidi
import * as React from "react";

function StarTool(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M32 47L12 62l8-24L2 24h22l8-23 8 23h22L44 38l8 24z"
      />
    </svg>
  );
}

export default StarTool;
